import axios from 'axios'

import { AuthService } from '@/core/service/auth.service'
import http from "http";
import https from "https";

const HttpClient = {
  count: 0
};
export class Http {

  static getHttpInstance(status={auth: false}) {
    let instance = HttpClient[status.auth ? 'auth' : 'default'];
    if(instance){
      return instance;
    }

    const httpAgent = new http.Agent({ keepAlive: true });
    const httpsAgent = new https.Agent({ keepAlive: true });

    ['default', 'auth'].forEach(type => {
      console.log('create httpClient : type[%s], no[%d]', type, ++HttpClient.count)

      const instance = HttpClient[type] = axios.create({
        baseURL: process.env.VUE_APP_USE_LOCAL_DEV_PROXY === 'true' ? '/' : process.env.VUE_APP_API_URL,
        withCredentials: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        },
        httpAgent, httpsAgent
      });

      instance._createdAt = new Date();

      if(type !== 'auth'){
        return;
      }

      instance.interceptors.request.use(request => {
        if (AuthService.isAccessTokenExpired()) {
          return AuthService.debounceRefreshTokens()
              .then((response) => {
                request.headers['GRM-ROOM-AUTH-TOKEN'] = AuthService.getRoomAuthToken()
                request.headers.common['Authorization'] = `Bearer ${AuthService.getAuthToken()}`
                return request
              }).catch(error => {
                // alert('로그인이 필요합니다.')
                // location.href = process.env.VUE_APP_LMS_URL
                return Promise.reject(error);
              })
        } else {
          request.headers['GRM-ROOM-AUTH-TOKEN'] = AuthService.getRoomAuthToken()
          request.headers.common['Authorization'] = `Bearer ${AuthService.getAuthToken()}`
          return request
        }
      }, error => {
        return Promise.reject(error)
      })
    });

    return HttpClient[status.auth ? 'auth' : 'default'];
  }

  constructor (status) {
    this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      withCredentials: true,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
      }
    })

    return this.init()
  }

  init () {
    this.instance.interceptors.request.use(request => {
      if (AuthService.isAccessTokenExpired()) {
        return AuthService.debounceRefreshTokens()
            .then((response) => {
              request.headers['GRM-ROOM-AUTH-TOKEN'] = AuthService.getRoomAuthToken()
              request.headers.common['Authorization'] = `Bearer ${AuthService.getAuthToken()}`
              return request
            }).catch(error => {
              // alert('로그인이 필요합니다.')
              // location.href = process.env.VUE_APP_LMS_URL
              return Promise.reject(error);
            })
      } else {
        request.headers['GRM-ROOM-AUTH-TOKEN'] = AuthService.getRoomAuthToken()
        request.headers.common['Authorization'] = `Bearer ${AuthService.getAuthToken()}`
        return request
      }
    }, error => {
      return Promise.reject(error)
    })

    return this.instance
  }
}
